export * from './UploadPhoto';
export { default as UploadPhoto } from './UploadPhoto';
